import { environment } from '../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

export enum AllowGpsModalResult {
	ALLOW,
	DISALLOW,
}

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export class GeolocationPermissionService {
	private static readonly PERMISSION_KEY = 'geolocation-permission-granted';

	static hasPermissionGranted(): boolean {
		if (isSafari) {
			return false;
		}
		const stored = localStorage.getItem(this.PERMISSION_KEY);
		return stored === 'true';
	}

	static setPermissionGranted(granted: boolean): void {
		if (isSafari) {
			return;
		}
		localStorage.setItem(this.PERMISSION_KEY, granted.toString());
	}

	static async checkBrowserPermission(): Promise<boolean> {
		if (!navigator.permissions) {
			return false;
		}

		try {
			const permission = await navigator.permissions.query({ name: 'geolocation' as any });
			return permission.state === 'granted';
		} catch (error) {
			return false;
		}
	}
}
@Component({
	selector: 'app-allow-gps-modal',
	templateUrl: './allow-gps-modal.component.html',
	styleUrls: ['allow-gps-modal.component.scss'],
})
export class AllowGpsModalComponent implements OnInit {
	environment = environment;
	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController): Promise<AllowGpsModalResult> {
		// Check if permission was previously granted
		if (GeolocationPermissionService.hasPermissionGranted()) {
			// Also check browser permission status
			const browserPermission = await GeolocationPermissionService.checkBrowserPermission();
			if (browserPermission) {
				return AllowGpsModalResult.ALLOW;
			}
		}

		return new Promise<AllowGpsModalResult>(async resolve => {
			const modal = await modalCtrl.create({
				component: AllowGpsModalComponent,
				cssClass: 'allow-gps-modal auto-height',
			});
			await modal.present();
			const result = await modal.onDidDismiss();
			if (result.data === undefined) {
				resolve(AllowGpsModalResult.DISALLOW);
			} else {
				resolve(result.data);
			}
		});
	}

	ngOnInit() {}

	onPositiveClick() {
		GeolocationPermissionService.setPermissionGranted(true);
		this.modalCtrl.dismiss(AllowGpsModalResult.ALLOW);
	}

	onNegativeClick() {
		GeolocationPermissionService.setPermissionGranted(false);
		this.modalCtrl.dismiss(AllowGpsModalResult.DISALLOW);
	}
}
